var map = {
	"../tab1/tab1.module": [
		"./src/app/tab1/tab1.module.ts",
		"common",
		"tab1-tab1-module"
	],
	"../tab2/tab2.module": [
		"./src/app/tab2/tab2.module.ts",
		"common",
		"tab2-tab2-module"
	],
	"../tab3/tab3.module": [
		"./src/app/tab3/tab3.module.ts",
		"common",
		"tab3-tab3-module"
	],
	"../tab4/tab4.module": [
		"./src/app/tab4/tab4.module.ts",
		"tab4-tab4-module"
	],
	"../tab5/tab5.module": [
		"./src/app/tab5/tab5.module.ts",
		"tab5-tab5-module"
	],
	"./auth/login/login.module": [
		"./src/app/auth/login/login.module.ts",
		"auth-login-login-module"
	],
	"./print/print.module": [
		"./src/app/print/print.module.ts",
		"print-print-module"
	],
	"./products/products.module": [
		"./src/app/products/products.module.ts",
		"products-products-module"
	],
	"./tab5/tab5.module": [
		"./src/app/tab5/tab5.module.ts",
		"tab5-tab5-module"
	],
	"./tabs/tabs.module": [
		"./src/app/tabs/tabs.module.ts",
		"tabs-tabs-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;